import React, { Component } from 'react';
import './navBar.css';
import { t } from 'i18next';
import { Link } from 'react-router-dom';
import Modal from '../modals/Modal';
import Notifications from '../notifications/notifications';

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchModal: {
        searchDSN: '',
        searchEmail: '',
        searchMACAdd: '',
      },
      showSearchDeviceByModal: false,
    };
    this.openSearchDeviceByModal = this.openSearchDeviceByModal.bind(this);
    this.closeSearchDeviceByModal = this.closeSearchDeviceByModal.bind(this);
    this.resetSearchDevice = this.resetSearchDevice.bind(this);
    this.handleSearchModalChange = this.handleSearchModalChange.bind(this);
  }

  openSearchDeviceByModal() {
    this.setState({
      showSearchDeviceByModal: true,
    });
  }

  closeSearchDeviceByModal() {
    this.setState({
      showSearchDeviceByModal: false,
    });
  }

  handleSearchModalChange(field) {
    const { searchModal } = this.state;
    return (e) => {
      this.setState({
        searchModal: {
          ...searchModal,
          [field]: e.target.value,
        },
      });
    };
  }

  resetSearchDevice() {
    this.setState({
      searchModal: {
        searchDSN: '',
        searchEmail: '',
        searchMACAdd: '',
      },
    });
  }

  render() {
    const {
      showSearchDeviceByModal,
      searchModal: {
        searchDSN, searchEmail, searchMACAdd,
      },
    } = this.state;

    const searchDeviceByContent = (
      <div>
        <div className="form-row">
          <div className="label">{`${t('tensorAnalytics.commonTerms.DSN')}:`}</div>
          <input value={searchDSN}
            onChange={this.handleSearchModalChange('searchDSN')}
            placeholder={t('tensorAnalytics.analyticsDashboardPage.DSNPlaceholder')}
          />
        </div>
        <div className="form-row">
          <div className="label">{`${t('tensorAnalytics.commonTerms.Email')}:`}</div>
          <input value={searchEmail}
            onChange={this.handleSearchModalChange('searchEmail')}
            placeholder={t('tensorAnalytics.analyticsDashboardPage.EmailPlaceholder')}
          />
        </div>
        <div className="form-row">
          <div className="label">{`${t('tensorAnalytics.commonTerms.MACAdd')}:`}</div>
          <input value={searchMACAdd}
            onChange={this.handleSearchModalChange('searchMACAdd')}
            placeholder={t('tensorAnalytics.analyticsDashboardPage.MACAddPlaceholder')}
          />
        </div>
        <div className="action">
          <button type="button"
            className="cancel"
            onClick={this.closeSearchDeviceByModal}
          >
            {`${t('tensorAnalytics.common.cancel')}`}
          </button>
          <div className="right">
            <button type="button"
              className="reset"
              onClick={this.resetSearchDevice}
            >
              {`${t('tensorAnalytics.analyticsDashboardPage.resetFilter')}`}
            </button>
            <Link to={`/deviceDetailDev/${searchDSN}`}
              onClick={this.closeSearchDeviceByModal}
            >
              <div className="button accept">
                {`${t('tensorAnalytics.common.accept')}`}
              </div>
            </Link>
          </div>
        </div>
      </div>
    );

    return (
      <div className="tensor-nav-bar">
        <div className={showSearchDeviceByModal ? 'show' : 'hide'}>
          <Modal close={this.closeSearchDeviceByModal}
            title={t('tensorAnalytics.analyticsDashboardPage.searchDeviceBy')}
            style={{
              minWidth: '300px',
              width: '40vw',
            }}
          >
            {searchDeviceByContent}
          </Modal>
        </div>
        <div className="nav-container">
          <div className={`nav-link ${window.location.pathname.startsWith('/Models') ? 'selected' : ''}`}>
            <Link to="/ModelsDev">Models</Link>
          </div>
          <div className={`nav-link ${window.location.pathname.startsWith('/Schedules') ? 'selected' : ''}`}>
            <Link to="/SchedulesDev">Schedules</Link>
          </div>
          <div className={`nav-link ${window.location.pathname.startsWith('/AnalyticsDashboard') ? 'selected' : ''}`}>
            <Link to="/AnalyticsDashboardDev">Results</Link>
          </div>
          <div className={`nav-link ${window.location.pathname.startsWith('/deviceDetail') ? 'selected' : ''}`}>
            <div role="button"
              tabIndex="0"
              onKeyDown={this.openSearchDeviceByModal}
              onClick={this.openSearchDeviceByModal}
            >
              {'Device Details'}
            </div>
          </div>
          <Notifications />
        </div>
      </div>
    );
  }
}

export default NavBar;
